<template>
  <div
    class="asc-report-grid-wrapper--container"
    data-automation-id="wrapper_report_grid"
  >
    <asc-container>
      <template slot="header">
        <asc-surface-title :title="title"></asc-surface-title>
      </template>
      <template slot="subheader">
        <asc-surface-support-text :text="getInfoMessage" />
      </template>
      <div class="asc-report-grid-wrapper--filters">
        <asc-filters
          id="123456"
          :dense="false"
          no-placeholder
          :display-error-message="false"
          :lookups="filterLookups"
          :fields="reportFilterFields"
          :on-filters-change="onFiltersChange"
          :on-submit="onFiltersSubmit"
          :on-disable-submit="onFiltersDisableSubmit"
        />
      </div>
      <asc-report-grid
        :values="values"
        :on-open="onOpen"
        :export-button-visible="exportButtonVisible"
        :on-open-report-summary="onOpenReportSummary"
        :grid-filters="gridFilters"
        :is-grid-data-loaded="isGridDataLoaded"
      ></asc-report-grid>
    </asc-container>
  </div>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscSurfaceSupportText from '@/components/atoms/AscSurfaceSupportText'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'
import AscFilters from '@/components/molecules/AscFilters'
import AscReportGrid from '@/components/molecules/AscReportGrid'

export default {
  name: 'AscReportGridWrapper',

  components: {
    AscReportGrid,
    AscContainer,
    AscFilters,
    AscSurfaceTitle,
    AscSurfaceSupportText,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    onFiltersChange: {
      type: Function,
      default: () => {},
    },
    onFiltersSubmit: {
      type: Function,
      default: () => {},
    },
    onFiltersDisableSubmit: {
      type: Function,
      default: () => {},
    },
    reportFilterFields: {
      type: Array,
      default: () => [],
    },
    filterLookups: {
      type: Array,
      default: () => [],
    },
    onOpenReportSummary: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {}
  },

  computed: {
    getInfoMessage() {
      const acmfAirline = this.filterLookups.find(
        lookup => lookup.id === 'acmfAirline',
      )

      return `Select a Platform and hit 'Submit' to see ACMF Reports list. Note that the ACMF Reports list selections only include ${
        acmfAirline && acmfAirline.items.length > 1 ? 'airlines and' : ''
      } platforms which provide ACMF data.`
    },
  },
}
</script>

<style lang="scss">
.asc-report-grid-wrapper--container {
  .asc-report-grid-wrapper--filters {
    margin-bottom: 22.19px;

    .asc-filters {
      .asc-base-selector {
        .asc-menu--wrap-container {
          left: 0 !important;
          min-width: 285px;
        }
      }
    }
  }
}
</style>
